

























import {Component} from "vue-property-decorator"
import Vue from "vue"
import data from "../../../metadata/_changelog.json"
import MarkdownIt from 'markdown-it';

import JdiContent from "@/components/JdiContent.vue"

@Component({
    components: {JdiContent}
})
export default class Changelog extends Vue {

    data = data
    protected md: MarkdownIt|null = null;

    mounted () {
        this.md = new MarkdownIt();
    }

    trim(i: string) {
        return i.substr(3)
    }

    parse(i: string|boolean) {
        if (i && this.md && i !== true) {
            const res = this.md.render(i)
            return res.replaceAll(/\(#([0-9]+)\)/g, '<a href="https://gitlab.com/jobilla/jobilla-design-system/-/issues/$1">(#$1)</a>')
        }
        return ''
    }

    get versions() {
        return Object.keys(data).sort().reverse()
    }
}
